/**
 * Copyright (c) 2025 Adaptive Chaos Labs, LLC
 * All rights reserved.
 */

/**
 * **`main`'s padding, declared once** — `AppLayout` pads the scrolling area by it, and the sticky title
 * bar (`PageFrame`) reaches back across it on three sides so content scrolling under the bar is covered
 * edge to edge. Two copies of these numbers would let the padding change and leave the bar short, which
 * is exactly how its edges showed (Todd, 2026-09-28).
 */
export const MAIN_PADDING = { base: 3, md: 6 } as const;

/** The same padding, negated — how far the bar reaches out to cover it. */
export const MAIN_PADDING_REACH = { base: -MAIN_PADDING.base, md: -MAIN_PADDING.md } as const;
